export const environment = {
  production: true,
  baseUrl: 'https://backend-dev.splurky.com/api',
  imageUrl: 'https://backend-dev.splurky.com/api/media/video-preview-s3',
  productUrl: 'https://backend-dev.splurky.com',
  pluginUrl: 'https://backend-dev.splurky.com',
  labelUrl: 'https://blazing-card-project-qa.s3.amazonaws.com/', // ?
  cloudName: 'splurky',
  cloudFolder: 'splurky-dev',
};
